import { useTranslation } from 'react-i18next';

interface EmptyFieldValueProps {
  'data-testid'?: string;
}

export const EmptyFieldValue = ({
  'data-testid': dataTestId = 'empty-field-value',
}: EmptyFieldValueProps = {}) => {
  const { t } = useTranslation();
  return (
    <span className="text-sm text-text-neutral-secondary italic" data-testid={dataTestId}>
      {t(($) => $.adaptivePlanner.itemPanel.customFields.emptyValue)}
    </span>
  );
};
